import WebSocketMessageRequest from '@/content/models/web-socket-message-request.model';
import { Store } from '@/core/store/core.store';
import KEYS from '@/values/keys';

class EdPresentationModeFactory {

    public createWebSocketMessageRequest = (type : string, topicId: string, onlySave : boolean = false, content ?: string, listener ?: string) => new WebSocketMessageRequest(type,
                                            KEYS.ROLES_MAPPED[Store.state.AuthStore.role],
                                            Store.state.AuthStore.user.fullName, Store.state.AuthStore.user.userId, onlySave, topicId, content, listener);
    
    public createWebSocketMessageRequestWithUserType = (type : string, topicId: string, userType : string, onlySave : boolean = false, content ?: string, listener ?: string, messageAttempt ?: number) =>
                                            new WebSocketMessageRequest(type, userType, Store.state.AuthStore.user.fullName, Store.state.AuthStore.user.userId, onlySave, topicId, content, listener, messageAttempt);
}

export default new EdPresentationModeFactory();